import moment from 'moment';

const formatDisplayDate = (date) => {
  if (!date) return '-';
  return moment(date).format('DD MMM YYYY');
};

export default formatDisplayDate;
